import React from 'react';
import { useEditor } from './EditorContext';
import { fitCanvasToContainer, setCanvasZoom } from '../canvasEditor';

export default function ZoomBar() {
  const { fabricRef, originalRef, viewportRef, zoomPercent, setZoomPercent } = useEditor();

  const applyZoom = (pct) => {
    const fc = fabricRef.current;
    const original = originalRef.current;
    if (!fc || !original?.width) return;
    setZoomPercent(pct);
    setCanvasZoom(fc, original, pct, viewportRef.current);
  };

  const fit = () => {
    const fc = fabricRef.current;
    const original = originalRef.current;
    if (!fc) return;
    fitCanvasToContainer(fc, viewportRef.current, original);
    setZoomPercent(100);
  };

  return (
    <div className="pixie-zoom-bar">
      <button type="button" className="pixie-zoom-btn" onClick={fit} title="Fit to screen">
        Fit
      </button>
      <input
        type="range"
        min={10}
        max={200}
        value={zoomPercent}
        onChange={(e) => applyZoom(Number(e.target.value))}
        className="pixie-zoom-slider"
        aria-label="Zoom"
      />
      <span className="pixie-zoom-label">{zoomPercent}%</span>
      <button type="button" className="pixie-zoom-btn" onClick={() => applyZoom(100)}>
        100%
      </button>
    </div>
  );
}
